import { ReactNode } from 'react'

import classNames from 'classnames'

import styles from './index.module.css'

export interface ChipProps {
  children: string | ReactNode
  active?: boolean
  icon?: React.ReactNode
  highlight?: boolean
  highlightCustomClass?: string
  onClick?: () => void
  [key: string]: any
}

/**
 * Element that represents an input, attribute, or action
 */
const Chip = ({
  children,
  active = false,
  icon,
  highlight = false,
  highlightCustomClass = '',
  onClick,
  ...rest
}: ChipProps) => {
  const wrapper = highlight
    ? [styles.chipWrapper, styles.highlight, highlightCustomClass]
    : [styles.chipWrapper]

  return (
    <div
      className={classNames([
        ...wrapper,
        active && 'border-3 border-brand-main p-2.25',
      ])}
      onClick={onClick}
      {...rest}
    >
      {icon}
      {children}
    </div>
  )
}

export default Chip
